
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { processOAuthCallback } from "@/utils/social-media/oauthService";
import { useToastContext } from "@/contexts/ToastContext";

export const OAuthCallback = () => {
  const [status, setStatus] = useState("Processing authentication...");
  const location = useLocation();
  const navigate = useNavigate();
  const { showSuccess, showError } = useToastContext();
  
  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');
      const platform = localStorage.getItem('oauthPlatform');
      const redirectUrl = localStorage.getItem('oauthRedirect') || '/admin/social-media/accounts';

      if (error) {
        setStatus(`Authentication failed: ${error}`);
        showError("Authentication failed", error);
        setTimeout(() => navigate(redirectUrl), 3000);
        return;
      }

      if (!code || !state) {
        setStatus("Missing required authentication parameters");
        showError("Authentication failed", "Missing required parameters");
        setTimeout(() => navigate(redirectUrl), 3000);
        return;
      }

      try {
        await processOAuthCallback(code, state);
        setStatus(`Successfully connected to ${platform}!`);
        showSuccess("Account connected", `Your ${platform} account has been connected successfully.`);
        setTimeout(() => navigate(redirectUrl), 1500);
      } catch (error: any) {
        setStatus(`Error: ${error.message}`);
        showError("Connection failed", error.message);
        setTimeout(() => navigate(redirectUrl), 3000);
      }
    };

    handleCallback();
  }, [location, navigate, showSuccess, showError]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-md w-full space-y-6 text-center">
        <Loader2 className="h-12 w-12 animate-spin mx-auto text-primary" />
        <h1 className="text-2xl font-bold">Connecting Your Account</h1>
        <p className="text-muted-foreground">{status}</p>
        <p className="text-sm">You'll be redirected automatically once the process completes.</p>
      </div>
    </div>
  );
};
